<template>
  <div class="incoming-tender-list-row-breakdown">
    <div class="tender-list-wrapper d-contents">
      <div class="tender-list incoming-tender-list incoming-tender-list_breakdown">
        <IncomingTenderListHeader
          class="incoming-tender-list-row_breakdown"
          :class="{
            'incoming-tender-list-row_breakdown-short': !showLabourMaterialTools,
          }"
          :currency="currency"
          breakdown-header
          :show-labour-material-tools="showLabourMaterialTools"
          :version-is-draft="versionIsDraft"
          @delete-breakdown="deleteBreakdown"
        />
        <IncomingTenderListBreakdownRow
          v-for="(row, rowIndex) in breakdownRows"
          :key="row.id"
          :row-index="rowIndex"
          :row="row"
          :currency="currency"
          :parent-row-index="parentRowIndex"
          :parent-row-id="parentRowId"
          :column-keys="columnKeys"
          :show-labour-material-tools="showLabourMaterialTools"
          :version-is-draft="versionIsDraft"
          :order-of-rows-ids="orderOfRowsIds"
          @delete-breakdown-row="
            deleteBreakdownRow({
              breakdownRowId: row.id,
              breakdownRowIndex: rowIndex,
              rowId: parentRowId,
            })
          "
        />
        <div
          v-if="!isNotInvitedIncomingTender && versionIsDraft"
          class="incoming-tender-list-row-breakdown__footer"
        >
          <div
            class="action-btn spacex-4 pointer"
            @click="createBreakdownRow({ rowId: parentRowId, total: null })"
          >
            <RoundedPlusIcon class="primary-icon" />
            <span class="primary fw-5 fs-14">{{ $t('Add subposition') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IncomingTenderListHeader from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListHeader';
  import IncomingTenderListBreakdownRow from '@/containers/incoming-tender/incoming-tender-list/IncomingTenderListBreakdownRow';
  import { mapActions, mapGetters } from 'vuex';
  import RoundedPlusIcon from '@/assets/icons/rounded-plus.svg';

  export default {
    name: 'IncomingTenderListBreakdown',
    components: {
      IncomingTenderListHeader,
      IncomingTenderListBreakdownRow,
      RoundedPlusIcon,
    },
    props: {
      currency: {
        type: String,
        required: true,
      },
      breakdownRows: {
        type: Array,
        required: true,
      },
      parentRowIndex: {
        type: Number,
        required: true,
      },
      parentRowId: {
        type: Number,
        required: true,
      },
      columnKeys: {
        type: Array,
        required: true,
      },
      showLabourMaterialTools: {
        type: Boolean,
        required: true,
      },
      versionIsDraft: {
        type: Boolean,
        required: true,
      },
      orderOfRowsIds: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        confirmBody: {
          title: this.$t('Delete breakdown?'),
          actionText: this.$t('Delete'),
          cancelText: this.$t('Return'),
          description: this.$t('This action can’t be undone.'),
          style: 'danger',
          revertButtons: true,
        },
      };
    },
    computed: {
      ...mapGetters({
        isNotInvitedIncomingTender: 'incomingTender/isNotInvitedIncomingTender',
      }),
    },
    methods: {
      ...mapActions('incomingTender', [
        'editIncomingTenderBreakdownCellValue',
        'createBreakdownRow',
        'deleteIncomingTenderBreakdownRow',
        'deleteIncomingTenderBreakdown',
      ]),
      ...mapActions({
        confirm: 'confirmModal/openModal',
      }),
      deleteBreakdownRow(breakdownRowInfo) {
        this.confirm({
          ...this.confirmBody,
          action: () => {
            this.deleteIncomingTenderBreakdownRow(breakdownRowInfo);
          },
        });
      },
      deleteBreakdown() {
        this.confirm({
          ...this.confirmBody,
          action: () => {
            this.deleteIncomingTenderBreakdown({ rowId: this.parentRowId });
          },
        });
      },
    },
  };
</script>
